<div class="rounded-xl p-2 sm:p-6">
    <div class="flex items-center justify-between mb-4">

        <h2 class="text-lg font-semibold text-indigo-900">{{ 'ONB_KEY_MGMT.KEY_MANAGEMENT_LIST' | translate }}</h2>
        <div class="flex justify-between gap-6">
            @if (isRelationshipOfficer) {
            <button class="flex  gap-2 bg-indigo-600 text-white px-6 py-2 rounded-lg text-sm font-semibold"
                (click)="openPopup()">
                + {{ 'ONB_KEY_MGMT.ADD_KEY_MANAGEMENT' | translate }}
            </button>
            }
            <app-back-button></app-back-button>
        </div>

    </div>

    <app-table [columns]="columns" [data]="list" [actions]="actions" [selectable]="false"></app-table>

    <div class="flex ">
        <button class="btn-primary" (click)="goToNext()">{{ 'COMMON.CONTINUE' | translate }}</button>
    </div>
</div>


<app-popup [(show)]="showPopup" [title]="isEditMode ? 'ONB_KEY_MGMT.EDIT_KEY_MANAGEMENT' : 'ONB_KEY_MGMT.ADD_KEY_MANAGEMENT'" [type]="'form'"
    [fields]="fields" [data]="formData" [onSave]="handleSave"
    [showFileDownload]="isEditMode || isPopupViewMode" (formChange)="onPopupFormChange($event)"
    width="w-full max-w-5xl"></app-popup>

<app-popup [(show)]="showDeletePopup" title="ONB_KEY_MGMT.DELETE_KEY_MANAGEMENT" [type]="'confirm'" [message]="deleteMessage"
    confirmText="COMMON.DELETE" cancelText="COMMON.CANCEL" (confirmed)="confirmDeleteKeyManagement()"></app-popup>